import { render, staticRenderFns } from "./CollectingForm.vue?vue&type=template&id=cdcacfb2"
import script from "./CollectingForm.vue?vue&type=script&lang=js"
export * from "./CollectingForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports